module.exports = __webpack_public_path__ + "media/images/app_icons/android-icon-72x72-d68fc750f68a7284e2d869a69b31b40f.png";